/**
 * DeployInfo. Contains data about the current deploy. This data is populated
 * from Fastly headers.
 *
 * NOTE(frontend-infra): Please do not add properties to this, or any other,
 * info objects without first consulting with us!
 */
import {kaPublishedContentVersion, kaStaticVersion} from "./fastly-data.ts";

/**
 * NOTE(frontend-infra): Tests that are using DeployInfo should mock the
 * accessors with:
 *      jest.spyOn(DeployInfo, "property", "get").mockReturnValue("value")
 *
 * Do not rely on the internal implementation of DeployInfo.
 */

const DeployInfo = {
    get commitSHA(): string {
        return kaPublishedContentVersion();
    },
    get staticVersion(): string {
        return kaStaticVersion();
    },
};

export default DeployInfo;
